import { Event } from '../Event'
import { Identity } from '../../constants'

export class PushNotificationsAllowedEvent extends Event {
  static displayName = 'Push Notifications Allowed'

  static allowedIdentities = [Identity.Guest, Identity.Consumer]
}
